import type { AuthState } from "../shared/auth";

export async function fetchAuthState(): Promise<AuthState> {
  const response = await fetch("/api/me", {
    headers: {
      accept: "application/json"
    }
  });

  const body: unknown = await response.json();
  return body as AuthState;
}

export async function logout(): Promise<void> {
  await fetch("/auth/logout", {
    method: "POST"
  });
}
